<template>
    <!-- TODO: refactor -->
    <div v-if="displayedCards.length > 0" ref="filtersContent" class="filters-content" @scroll="stickFiltersControls">
        <div class="tw-py-4">
            <div v-for="(service, index) in displayedCards" :key="service.id">
                <!-- TO-DO: Fix url -->
                <service-card
                    :url="`/${lang}/${service.region.slug}/${service.slug}/${service.id}`"
                    :data="service"
                    :class="'card-horizontal'"
                    :alt="service.title"
                    :img-min="200"
                    :img-max="600"
                    :img-loading="index === 0 ? 'eager' : 'lazy'"
                    img-sizes="(min-width: 2500px) 450px, (min-width: 1200px) calc((50vw - 5rem) * 0.4), (min-width: 768px) calc((100vw - 5rem) * 0.4), (min-width: 576px) calc((100vw - 2rem) * 0.4), calc(100vw - 2rem)"
                >
                </service-card>
                <cta-card
                    v-if="(index + 1) % 5 === 0"
                    :title="translate('map.cta_title')"
                    :description="translate('map.cta_description')"
                    :cta-text="translate('map.cta_btn_text')"
                    :cta-url="`/${lang}/custom-private-tours`"
                ></cta-card>
            </div>
        </div>
        <pagination :paginator="paginator" nav-classes="tw-mb-6" :use-current-path="true" />
    </div>

    <div v-show="displayedCards.length === 0" class="filters-content">
        <div class="tw-mt-32">
            <img class="tw-mx-auto" :src="noResults" alt="No Services" />
            <p class="tw-text-dark-green tw-font-bold tw-text-center tw-text-lg tw-mt-6 tw-mb-4">
                {{ translate('map.no_services') }}
            </p>
        </div>
    </div>

    <div class="filters-map-container">
        <div class="map-window-wrapper">
            <div id="mapWindow" ref="mapWindow">
                <div class="map-service-card">
                    <div class="card-image-container">
                        <img
                            v-show="mapWindowContent.discount_rate > 0"
                            class="card-discount-icon"
                            src="../../../images/discount-icon.svg"
                            loading="lazy"
                            :alt="'Discount ' + mapWindowContent.discount_rate + '%'"
                        />
                        <img
                            src="../../../images/close-icon.svg"
                            class="card-close-icon"
                            @click.prevent="hideMapWindow"
                            alt="Close"
                        />
                        <img
                            class="card-image"
                            :src="mapWindowContent.photo"
                            :srcset="mapWindowContent.photoSrcSet"
                            :alt="mapWindowContent.title"
                            sizes="(min-width: 1408px) 350px, (min-width: 1200px) 25vw, (min-width: 568px) 50vw, 100vw"
                        />
                    </div>
                    <a
                        class="card-text-container"
                        :href="mapWindowContent.serviceUrl"
                        v-if="mapWindowContent.serviceUrl"
                        target="_blank"
                        @click="openService(mapWindowContent)"
                    >
                        <p class="card-breadcrumb tw-text-xs tw-font-medium tw-text-grey-200 tw-line-clamp-1">
                            {{ mapWindowContent.regionName }} &gt;
                            {{ mapWindowContent.categoryName }}
                        </p>
                        <h5 class="card-title">{{ mapWindowContent.title }}</h5>
                        <div class="card-pricetag-wrapper">
                            <span class="card-pricetag">
                                <span class="card-pricetag-small-text">
                                    <span v-if="mapWindowContent.group_num_for_min_price > 1">
                                        {{ translate('map.price_group', mapWindowContent.group_num_for_min_price) }}
                                    </span>
                                    <span v-else>{{ translate('map.price_person') }}</span>
                                </span>
                                <span class="card-pricetag-text"
                                    >{{ translate('map.price_from') }} {{ mapWindowContent.price }}</span
                                >
                            </span>
                        </div>
                    </a>
                </div>
                <div class="map-service-card-mobile">
                    <div
                        v-if="mapWindowContent.photo"
                        class="card-image-container"
                        :style="{ 'background-image': 'url(' + mapWindowContent.photo + ')' }"
                    ></div>
                    <a
                        class="card-text-container"
                        :href="mapWindowContent.serviceUrl"
                        v-if="mapWindowContent.serviceUrl"
                        target="_blank"
                        @click="openService(mapWindowContent)"
                    >
                        <p class="card-breadcrumb tw-line-clamp-1 tw-mb-1">
                            {{ mapWindowContent.regionName }} &gt;
                            {{ mapWindowContent.categoryName }}
                        </p>
                        <h5 class="card-title tw-line-clamp-2">{{ mapWindowContent.title }}</h5>
                    </a>
                    <span class="card-pricetag">
                        <span class="card-pricetag-small-text">
                            <span v-if="mapWindowContent.group_num_for_min_price > 1">
                                <p>{{ translate('map.price_group') }}</p>
                                <p>
                                    {{ translate('map.price_group_amount', mapWindowContent.group_num_for_min_price) }}
                                </p>
                            </span>
                            <span v-else>{{ translate('map.price_person') }}</span>
                        </span>
                        <span class="card-pricetag-text"
                            >{{ translate('map.price_from') }} {{ mapWindowContent.price }}</span
                        >
                    </span>
                </div>
            </div>
            <div id="mapContainer" style="width: 100%; height: 100%"></div>
        </div>
    </div>

    <div class="filters-controls-bottom">
        <div class="filters-controls-list-view">
            <button class="btn btn-sm btn-primary tw-mr-2" @click="displayMapView">
                {{ translate('map.map_view') }}
            </button>
            <button class="btn btn-sm btn-primary open-modal" data-filters>
                <span v-if="appliedFiltersCount">({{ appliedFiltersCount }})</span>
                {{ translate('map.filters.button') }}
            </button>
        </div>
        <div class="filters-controls-map-view">
            <button class="btn btn-sm btn-primary tw-mr-2" @click="displayListView">
                {{ translate('map.list_view') }}
            </button>
            <button class="btn btn-sm btn-primary open-modal" data-filters>
                <span v-if="appliedFiltersCount">({{ appliedFiltersCount }})</span>
                {{ translate('map.filters.button') }}
            </button>
        </div>
    </div>
    <div class="modal" data-filters>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ translate('map.filters.title') }}</p>
                <button class="close modal-close-button" aria-label="close">
                    <img src="../../../images/close-icon.svg" class="close-icon" alt="Close" loading="lazy" />
                </button>
            </header>
            <section class="modal-card-body">
                <fieldset class="input-wrapper">
                    <label for="destination" class="label-uppercase">{{ translate('map.choose_destination') }}</label>
                    <select
                        id="destination"
                        v-model="filters.destination"
                        @change="resetCategory"
                        class="dropdown-menu"
                    >
                        <option
                            v-for="destination in destinations"
                            :key="destination.id"
                            :value="destination.id"
                            class="dropdown-menu-item"
                        >
                            {{ destination.name }}
                        </option>
                    </select>
                </fieldset>
                <fieldset class="input-wrapper tw-mt-6">
                    <label for="category" class="label-uppercase">{{ translate('map.choose_category') }}</label>
                    <select id="category" v-model="filters.category" @change="resetTags" class="dropdown-menu">
                        <option disabled :value="null" class="dropdown-menu-item">
                            {{ translate('map.choose_category') }}
                        </option>
                        <option
                            v-for="category in availableCategories"
                            :key="category.id"
                            :value="category.id"
                            class="dropdown-menu-item"
                        >
                            {{ category.name }}
                        </option>
                    </select>
                </fieldset>

                <fieldset class="input-wrapper tw-mt-6">
                    <label for="persons" class="label-uppercase">{{ translate('map.filters.num_people') }}</label>
                    <input id="persons" type="number" min="1" v-model="filters.persons" class="input-field-app" />
                </fieldset>

                <fieldset class="input-wrapper tw-mt-6">
                    <legend class="label-uppercase">{{ translate('map.filters.price') }}</legend>
                    <div class="inline-input-fields-container">
                        <div>
                            <input
                                type="number"
                                min="1"
                                v-model="filters['price-from']"
                                class="input-field-app inline tw-mr-auto"
                                placeholder="Min (EUR)"
                                title="Min (EUR)"
                            />
                        </div>
                        <div>
                            <input
                                type="number"
                                min="2"
                                v-model="filters['price-to']"
                                class="input-field-app inline tw-ml-auto"
                                placeholder="Max (EUR)"
                                title="Max (EUR)"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset class="input-wrapper tw-mt-6">
                    <label for="in-advance" class="label-uppercase">{{ translate('map.filters.in_advance') }}</label>
                    <select id="in-advance" v-model="filters['in-advance']" class="dropdown-menu">
                        <option :value="null">{{ translate('map.filters.not_selected') }}</option>
                        <option v-for="(hour, index) in advanceHours" :key="index" :value="hour.value">
                            {{ hour.label }}
                        </option>
                    </select>
                </fieldset>

                <div v-for="category in categories" :key="category.id">
                    <fieldset class="input-wrapper tw-mt-6" v-if="filters.category === category.id">
                        <legend class="label-uppercase">{{ translate('map.filters.tags') }}</legend>
                        <div class="checkbox-tags-container">
                            <label v-for="tag in category.tags" :for="tag.id" :key="tag.id">
                                <input
                                    type="checkbox"
                                    :id="tag.id"
                                    :value="tag.id"
                                    v-model="filters.tags"
                                    class="checkbox-tag-input"
                                />
                                <span class="checkbox-tag-label">{{ tag.name }}</span>
                            </label>
                        </div>
                    </fieldset>
                </div>

                <fieldset class="input-wrapper tw-mt-6">
                    <legend class="label-uppercase">{{ translate('map.filters.additional_characteristics') }}</legend>
                    <div class="radio-checkbox-item checkbox-rows">
                        <label
                            v-for="amenity in amenities"
                            :for="amenity.id"
                            :key="amenity.id"
                            class="checkbox-rows-item-two"
                        >
                            <input type="checkbox" :id="amenity.id" :value="amenity.id" v-model="filters.amenities" />
                            <span class="radio-checkbox-label">{{ amenity.name }}</span>
                        </label>
                    </div>
                </fieldset>

                <fieldset class="input-wrapper tw-mt-6">
                    <legend class="label-uppercase tw-mb-2">{{ translate('map.filters.guided_tour') }}</legend>
                    <div>
                        <div class="radio-checkbox-item inline tw-mr-8">
                            <label for="guided-true">
                                <input type="radio" value="1" id="guided-true" v-model="filters['only-guided']" />
                                <span class="radio-checkbox-label inline">{{
                                    translate('map.filters.select_yes')
                                }}</span>
                            </label>
                        </div>
                        <div class="radio-checkbox-item inline">
                            <label for="guided-false">
                                <input type="radio" value="0" id="guided-false" v-model="filters['only-guided']" />
                                <span class="radio-checkbox-label inline">{{
                                    translate('map.filters.select_no')
                                }}</span>
                            </label>
                        </div>
                    </div>
                    <button @click.prevent="filters['only-guided'] = null" class="btn-quinary">
                        {{ translate('map.reset_filter') }}
                    </button>
                </fieldset>

                <fieldset class="input-wrapper tw-mt-6">
                    <legend class="label-uppercase tw-mb-2">{{ translate('map.filters.private_group') }}</legend>
                    <div>
                        <div class="radio-checkbox-item inline tw-mr-8">
                            <label for="private-true">
                                <input
                                    type="radio"
                                    value="1"
                                    id="private-true"
                                    v-model="filters['only-private-group']"
                                />
                                <span class="radio-checkbox-label inline">{{
                                    translate('map.filters.select_yes')
                                }}</span>
                            </label>
                        </div>
                        <div class="radio-checkbox-item inline">
                            <label for="private-false">
                                <input
                                    type="radio"
                                    value="0"
                                    id="private-false"
                                    v-model="filters['only-private-group']"
                                />
                                <span class="radio-checkbox-label inline">{{
                                    translate('map.filters.select_no')
                                }}</span>
                            </label>
                        </div>
                    </div>
                    <button @click.prevent="filters['only-private-group'] = null" class="btn-quinary">
                        {{ translate('map.reset_filter') }}
                    </button>
                </fieldset>

                <fieldset class="input-wrapper tw-mt-6">
                    <legend class="label-uppercase tw-mb-2">{{ translate('map.filters.mixed_group') }}</legend>
                    <div>
                        <div class="radio-checkbox-item inline tw-mr-8">
                            <label for="mixed-true">
                                <input type="radio" value="1" id="mixed-true" v-model="filters['only-mixed-group']" />
                                <span class="radio-checkbox-label inline">{{
                                    translate('map.filters.select_yes')
                                }}</span>
                            </label>
                        </div>
                        <div class="radio-checkbox-item inline">
                            <label for="mixed-false">
                                <input type="radio" value="0" id="mixed-false" v-model="filters['only-mixed-group']" />
                                <span class="radio-checkbox-label inline">{{
                                    translate('map.filters.select_no')
                                }}</span>
                            </label>
                        </div>
                    </div>
                    <button @click.prevent="filters['only-mixed-group'] = null" class="btn-quinary">
                        {{ translate('map.reset_filter') }}
                    </button>
                </fieldset>
            </section>
            <footer class="modal-card-foot">
                <button class="button btn btn-md btn-quinary btn-l btn-wa" @click="resetAllFilters">
                    {{ translate('map.reset_filter') }}
                </button>
                <button
                    class="button close is-success btn btn-primary btn-md btn-r filter-icon btn-wa"
                    @click="applyServiceFilters(true, filters['sort-price'])"
                >
                    {{ translate('map.filters.apply_filters') }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted, computed, watch } from 'vue';
import i18n from '@/js/vue/mixins/i18n';
import { useMap } from '@/js/vue/logic/mapLogic';
import filterLogic from '@/js/vue/logic/filters';
import filterLayout from '@/js/vue/logic/filtersLayout';
import Pagination from './Pagination.vue';
import noResults from '@/images/empty-list/no-results.svg';

export default {
    name: 'CardsWithMapAndFilters',
    components: {
        Pagination,
    },
    inject: ['lang', 'translations'],
    mixins: [i18n],
    props: {
        services: {
            type: Object,
            required: true,
        },
        categories: {
            type: Object,
            required: true,
        },
        destinations: {
            type: Object,
            required: true,
        },
        amenities: {
            type: Object,
            required: true,
        },
        initialCategorySlug: {
            type: String,
            //required: true,
            default: '',
        },
        initialDestinationSlug: {
            type: String,
            required: true,
        },
    },
    mounted() {
        window.test = this;
    },
    setup(props, { emit }) {
        window.onpopstate = function () {
            location.reload();
        };

        // What else can you search modal
        onMounted(() => {
            // open/close modal (filters)
            const openBtns = document.querySelectorAll('.open-modal[data-filters]');

            openBtns.forEach((btn) => {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();

                    const modal = document.querySelector('.modal[data-filters]');
                    modal.classList.toggle('is-active');
                    document.body.classList.toggle('prevent-scroll');

                    const closeBtns = modal.querySelectorAll('.close');

                    closeBtns.forEach((close) => {
                        close.addEventListener('click', function (e) {
                            e.preventDefault();
                            modal.classList.remove('is-active');
                            document.body.classList.remove('prevent-scroll');
                        });
                    });
                });
            });
        });

        /*
         | -------
         | Data
         | -------
         */
        const { data, ...pagination } = props.services;

        let displayedCards = ref(data);
        const paginator = ref(pagination);

        const advanceHoursArray = [1, 2, 4, 8, 16, 24, 32, 48];

        const generateHourLabel = (hour) => {
            if (lang === 'hr') {
                if (hour === 1) return `${hour} sat`;
                if ((hour >= 2 && hour <= 4) || hour === 24 || hour === 32) return `${hour} sata`;
                return `${hour} sati`;
            } else {
                return `${hour} ${hour === 1 ? 'hour' : 'hours'}`;
            }
        };

        const advanceHours = computed(() => {
            return advanceHoursArray.map((hour) => ({
                value: hour,
                label: generateHourLabel(hour),
            }));
        });

        const destinationInfo = findDestinationBySlug(props.initialDestinationSlug);

        /*
         | -------
         | Filters
         | -------
         */

        const FILTER_URL = '/api/services';
        const MAP_URL = '/api/services/markers';

        let filters = reactive({
            persons: null,
            'price-from': null,
            'price-to': null,
            'in-advance': null,
            tags: [],
            amenities: [],
            'only-guided': null,
            'only-private-group': null,
            'only-mixed-group': null,
            'sort-price': null,
            category: props.initialCategorySlug ? findCategoryIdBySlug(props.initialCategorySlug) : null,
            destination: destinationInfo?.id,
        });

        // get current destination
        let currentDestination = computed(() => {
            return findDestinationById(filters.destination);
        });

        // extract ids of current destination's available categories
        let availableCategoriesIds = computed(() => {
            return new Set(currentDestination.value?.available_categories?.map((cat) => cat.id) || []);
        });

        // filter available categories based on the current destination
        let availableCategories = computed(() => {
            return props.categories.filter(
                (cat) => availableCategoriesIds.value.size === 0 || availableCategoriesIds.value.has(cat.id)
            );
        });

        const appliedFiltersCount = computed(() => {
            return Object.values(filters).filter((value) => {
                return value !== null && value !== undefined && (!Array.isArray(value) || value.length > 0);
            }).length;
        });

        const filtersApplied = document.querySelectorAll('.filters-applied');
        const filtersButton = document.querySelector('[data-filters]');
        const filtersButtonTextElement = filtersButton.querySelector('span:last-child');
        const appliedFiltersText = filtersButton.getAttribute('data-applied-filters-text');
        const defaultText = filtersButton.getAttribute('data-default-text');

        watch(
            appliedFiltersCount,
            (newCount) => {
                if (filtersButtonTextElement) {
                    filtersButtonTextElement.textContent =
                        appliedFiltersCount.value > 0 ? appliedFiltersText : defaultText;
                }

                if (newCount > 0) {
                    filtersApplied.forEach((btn) => {
                        btn.textContent = '(' + newCount + ')';
                    });
                }
            },
            { immediate: true }
        );

        const selectedCategorySlug = ref(props.initialCategorySlug);
        const selectedDestinationSlug = ref(props.initialDestinationSlug);

        const { parseFiltersFromURLParams, buildURL, setFilterValue, getSearchQuery } = filterLogic(
            filters,
            FILTER_URL
        );

        parseFiltersFromURLParams();

        const { mapWindowContent, mapWindow, renderMap, hideMapWindow, openService } = useMap(filters, MAP_URL);

        // render map
        onMounted(() => {
            renderMap();
        });

        function applyServiceFilters(rerenderMap, sortValue, sortingApplied = false) {
            setFilterValue('sort-price', sortValue);
            axios(buildURL())
                .then((r) => {
                    const { data, ...pagination } = r.data;
                    displayedCards.value = data;
                    paginator.value = pagination;

                    selectedCategorySlug.value = findCategorySlugById(filters.category);
                    selectedDestinationSlug.value = findDestinationSlugById(filters.destination);

                    const url = URLBuilder(location.href)
                        .withQuery(getSearchQuery())
                        .withDestination(selectedDestinationSlug.value)
                        .withCategory(selectedCategorySlug.value)
                        .get();

                    let priceDL = false;
                    if (filters['price-from'] || filters['price-to']) {
                        priceDL = true;
                    }
                    if (!sortingApplied) {
                        dataLayer.push({
                            event: 'filterApply',
                            category: selectedCategorySlug.value ? selectedCategorySlug.value : 'not set',
                            people: filters['persons'] ? filters['persons'] : 0,
                            price: priceDL,
                            condition: filters['in-advance'] ? true : false,
                            features: filters['amenities'].length ? true : false,
                            guided: filters['only-guided'] ? true : false,
                            private: filters['only-private-group'] ? true : false,
                            mixed: filters['only-mixed-group'] ? true : false,
                        });
                    }

                    window.history.pushState({}, '', url);
                    location.reload();
                    if (rerenderMap) renderMap();
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        // reset filters
        function resetTags() {
            setFilterValue('tags', []);
        }

        // reset categories
        function resetCategory() {
            setFilterValue('category', null);
        }

        function resetAllFilters() {
            // reload page without query params
            window.location.href = window.location.pathname;
        }

        /*
         | -------
         | Layout
         | -------
         */

        const layout = filterLayout();

        // close map window when the list is displayed
        window.addEventListener('listViewDisplayed', () => {
            hideMapWindow();
        });

        onMounted(() => {
            layout.initializeLayout();
        });

        /*
         | -------
         | Helpers
         | -------
         */

        function findCategoryBySlug(slug) {
            return props.categories.find((category) => category.slug === slug);
        }

        function findCategorySlugById(id) {
            return props.categories.find((category) => category.id === id)?.slug;
        }

        function findCategoryIdBySlug(slug) {
            return findCategoryBySlug(slug)?.id;
        }

        function findDestinationBySlug(slug) {
            return props.destinations.find((dest) => dest.slug === slug);
        }

        function findDestinationSlugById(id) {
            return props.destinations.find((dest) => dest.id === id)?.slug;
        }

        function findDestinationById(id) {
            return props.destinations.find((dest) => dest.id === id);
        }

        function URLBuilder(url) {
            url = new URL(url);
            // disassemble URL - path & query
            const pathAndQuery = url.pathname + url.search;
            const regex = new RegExp(/^\/(.{2})\/([^\/?]+)\/?([^\/?]+)?/);
            const [, lang, destination, category] = regex.exec(pathAndQuery) || [];

            return {
                path: url.pathname,
                query: url.search,
                withDestination: function (newDestination) {
                    if (newDestination) this.destination = newDestination;
                    this.updatePath();
                    return this;
                },
                withCategory: function (newCategory) {
                    if (newCategory) this.category = newCategory;
                    this.updatePath();
                    return this;
                },
                updatePath: function () {
                    this.path = `/${lang}`;
                    if (this.destination) this.path += `/${this.destination}`;
                    if (this.category) this.path += `/${this.category}`;
                },

                withQuery: function (newQuery = '') {
                    this.query = newQuery.startsWith('?') ? newQuery : '?' + newQuery;
                    return this;
                },
                get: function (withQuery = true) {
                    return withQuery ? this.path + this.query : this.path;
                },
            };
        }

        return {
            renderMap,
            mapWindow,
            mapWindowContent,
            hideMapWindow,
            openService,
            destinationInfo,
            displayedCards,
            paginator,
            advanceHours,
            filters,
            resetTags,
            resetCategory,
            applyServiceFilters,
            resetAllFilters,
            selectedCategorySlug,
            findCategoryBySlug,
            noResults,
            appliedFiltersCount,
            currentDestination,
            availableCategories,
            displayMapView: layout.displayMapView,
            displayListView: layout.displayListView,
            stickFiltersControls: layout.stickFiltersControls,
        };
    },
};
</script>
